if (!window.Eurus.loadedScript.has('locales-form.js')) {
  window.Eurus.loadedScript.add('locales-form.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xLocalizationForm', () => ({ 
        openCountry: false,
        loading: false,
        cachedResults: false,
        
        async submit(value, input) {
          this.$el.closest("#localization_form").querySelector('#'+input).value = value;

          if (input == 'currency_selector') {
            // Extract and store the new region in localStorage
            let newRegion = 'us'; // Default to US
            
            if (value.includes('es-mx') || value.includes('MX')) {
              newRegion = 'es-mx';
            }

            // Note: 'es' and 'US' values are both treated as 'us' region
            
            localStorage.setItem('userRegion', newRegion);
            console.log('Region updated in localStorage:', newRegion);
          }

          if (input != 'locale_selector') {
            // Set flags for actions after page reload
            sessionStorage.setItem('resetCartCheckbox', 'true');
            sessionStorage.setItem('clearCartAfterRegionChange', 'true');
            
            console.log('Region change initiated, cart will be cleared after page reload');
          }   
          
          // Submit the localization form immediately
          this.$el.closest("#localization_form").submit();
        },
        
        loadCountry(el) {
          if (this.cachedResults) {
            this.openCountry = true;
            return true
          }
          let countrySelector = el.closest(".country-selector");
          let optionEL = countrySelector.querySelector(".country-options");

          this.loading = true;
          fetch(window.Shopify.routes.root + '?section_id=country-selector')
          .then(reponse => {
            return reponse.text();
          })
          .then((response) => {
            const parser = new DOMParser();
            const content = parser.parseFromString(response,'text/html').getElementById("list-country").innerHTML;
            optionEL.innerHTML = content;
            this.cachedResults = true;
            this.openCountry = true;
          })
          .finally(() => {
            this.loading = false;
          })
        },
      }))
      
      // Check if cart should be cleared after region change
      if (sessionStorage.getItem('clearCartAfterRegionChange') === 'true') {
        console.log('Detected region change, clearing cart now...');
        sessionStorage.removeItem('clearCartAfterRegionChange');
        
        // Clear cart after page has loaded with new region
        setTimeout(async () => {
          try {
            // Use the clear endpoint
            const clearResponse = await fetch('/cart/clear.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            });
            
            if (clearResponse.ok) {
              console.log('Cart cleared after region change');
              
              // Wait a moment then refresh the cart display
              setTimeout(() => {
                if (Alpine.store('xMiniCart')) {
                  Alpine.store('xMiniCart').reLoad();
                  console.log('Cart display refreshed');
                }
                
                // Reload the page to show empty cart
                window.location.reload();
              }, 500);
            } else {
              console.warn('Cart clear failed, trying update method');
              
              // Fallback: get cart and update all items to 0
              const cartResponse = await fetch('/cart.js');
              if (cartResponse.ok) {
                const cart = await cartResponse.json();
                if (cart.items && cart.items.length > 0) {
                  const updates = {};
                  cart.items.forEach(item => {
                    updates[item.key] = 0;
                  });
                  
                  await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates })
                  });
                  
                  console.log('Cart cleared via update method');
                  setTimeout(() => window.location.reload(), 500);
                }
              }
            }
          } catch (error) {
            console.error('Error clearing cart after region change:', error);
          }
        }, 500);
      }
    });
  });
}